"use strict";
// Set defaults globally for every Swal.fire/swal.fire call.
const swalDefaults = {
  width: 500,
  heightAuto: false,
  padding: '2.5rem',
  buttonsStyling: false,
  reverseButtons: true,
  customClass: {
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-light',
  },
};

if (typeof Swal !== 'undefined' && typeof Swal.mixin === 'function') {
  const SwalWithDefaults = Swal.mixin(swalDefaults);
  window.Swal = SwalWithDefaults;
  window.swal = SwalWithDefaults;
}
